module.exports = __webpack_public_path__ + "4e3d4a2aa7be8d3bd8adc2e9bad10da0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pumpkin.png
// module id = 2717
// module chunks = 0